export const isReviewEdited = (r) =>
  Array.isArray(r.edit_history) && r.edit_history.length > 0;
export const isThreadEdited = (t) =>
  !!(t.thread_history && Object.keys(t.thread_history).length);
export const isCommentEdited = (c) =>
  !!(c.comment_history && Object.keys(c.comment_history).length);
